import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useCallback, useState } from "react";
import { normalizeIANATimeZone, normalizeTimeZone } from "@chronosphereio/core";
import { useQueryParam, StringParam } from "use-query-params";
import { useDeepMemo } from "../../core";
export const TimeZoneContext = /*#__PURE__*/ createContext(undefined);
export function TimeZoneProvider(props) {
    const { children, userTimeZone, initialTimeZone, disableURLParams } = props;
    const defaultTimeZone = initialTimeZone ?? userTimeZone;
    const [timeZoneQueryParam, setTimeZoneQueryParam] = useQueryParam('timeZone', StringParam);
    const [timeZoneState, setTimeZoneState] = useState(defaultTimeZone);
    let timeZone = defaultTimeZone;
    if (disableURLParams) {
        timeZone = timeZoneState;
    } else if (timeZoneQueryParam) {
        timeZone = timeZoneQueryParam;
    }
    const setTimeZone = useCallback((newTimeZone)=>{
        const normalizedNewTimeZone = normalizeIANATimeZone(newTimeZone);
        const normalizedDefaultTimeZone = normalizeIANATimeZone(defaultTimeZone);
        if (disableURLParams) {
            setTimeZoneState(newTimeZone);
        } else {
            if (normalizedNewTimeZone === normalizedDefaultTimeZone) {
                setTimeZoneQueryParam(null);
            } else {
                setTimeZoneQueryParam(newTimeZone);
            }
        }
    }, [
        disableURLParams,
        setTimeZoneQueryParam,
        defaultTimeZone
    ]);
    // We use useDeepMemo to prevent this from re-running on every query param change.
    // There should be no performace implication as the dependency array is small.
    const ctx = useDeepMemo(()=>{
        return {
            userTimeZone,
            timeZone,
            setTimeZone
        };
    }, [
        userTimeZone,
        timeZone,
        setTimeZone
    ]);
    return /*#__PURE__*/ _jsx(TimeZoneContext.Provider, {
        value: ctx,
        children: children
    });
}
export function useTimeZone() {
    const ctx = useContext(TimeZoneContext);
    return {
        userTimeZone: normalizeTimeZone(ctx?.userTimeZone),
        // If TimeZoneProvider is missing from the React tree, default to the account time zone first, followed by the local time zone.
        timeZone: normalizeTimeZone(ctx?.timeZone ?? ctx?.userTimeZone),
        setTimeZone: ctx?.setTimeZone
    };
}

//# sourceMappingURL=TimeZoneProvider.js.map